export { default } from './SlugLink';
